(function () {
    const buttonFirstPage = $('.js-back-button-first-page');
    const buttonLinkNode = $('.js-back-button-link');
    let backButtonRout = [];

    if (buttonLinkNode.length > 0) {
        //Проверяем первая страница процесса или нет. Для первой страницы нужно добавлять соответвующий js класс "js-back-button-first-page"
        if (buttonFirstPage.length > 0) {
            //Если да, то прячем кнопку назад
            buttonFirstPage.hide();

            //Очищаем localStorage
            localStorage.removeItem('backButtonRout');

            //Добавляем текущий путь в массив
            backButtonRout.push(location.pathname);

            //Преобразуем в строку и отправляем в localStorage
            JSON.stringify(backButtonRout)
            localStorage.setItem('backButtonRout', JSON.stringify(backButtonRout));
        } else {
            //Если не первая страница, то забираем массив с путями из хранилища и преобразуем в массив
            backButtonRout = JSON.parse(localStorage.getItem('backButtonRout'));

            //Деламе запись в localStorage только если это не текущая страница
            if (backButtonRout[(backButtonRout.length - 1)] !== location.pathname) {
                //Добавлем текущий путь
                backButtonRout.push(location.pathname);

                //Преобразуем в строку и отправляем в localStorage
                JSON.stringify(backButtonRout)
                localStorage.setItem('backButtonRout', JSON.stringify(backButtonRout));
            }
        }

        buttonLinkNode.on('click', function (e) {
            e.preventDefault();

            //При клике получаем значение хранилища
            backButtonRout = JSON.parse(localStorage.getItem('backButtonRout'));

            //Записываем значение пути, на который надо вернуться. Он второй с конца.
            const linkPath = backButtonRout[(backButtonRout.length - 2)]

            //Очищаем массив от последних двух значений, содержащих текущий путь и путь на который делаем переход
            backButtonRout.splice(backButtonRout.length - 2, 2);

            //Преобразуем в строку и отправляем в localStorage
            JSON.stringify(backButtonRout)
            localStorage.setItem('backButtonRout', JSON.stringify(backButtonRout));

            //Перекидываем пользователя на предыдущую страницу
            location.href = linkPath
        })
    }
})();
